/** Akıllı Arama ile aynı host sözleşmesini uygular: www eşdeğer, diğer alt alan adları ayrıdır. */
export const allowsAssistantDomain = (config, pageUrl = globalThis.window?.location?.href || '') => {
  const domains = config?.allowedDomains;
  if (domains === undefined || domains === null) return true;
  if (!Array.isArray(domains)) return false;
  if (domains.length === 0) return true;
  try {
    const url = new URL(pageUrl);
    if (!['https:', 'http:'].includes(url.protocol) || url.username || url.password) return false;
    const host = url.hostname.toLowerCase().replace(/^www\./, '');
    return domains.some((domain) => typeof domain === 'string' && domain === host);
  } catch {
    return false;
  }
};
